// extracted by mini-css-extract-plugin
module.exports = {"section":"PlasmicInfoSection_section__j4L3A","sectionHeading":"PlasmicInfoSection_sectionHeading__IfERh","rawNull__tiSaY":"PlasmicInfoSection_rawNull__tiSaY__qHg0z"};